module.exports = __webpack_public_path__ + "static/media/education.32092f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/education.png
// module id = 5757
// module chunks = 0